<template>
  <v-snackbar
    v-model="show"
    location="top"
    timeout="3000"
    single-line
    :color="getSnackBarColor()"
  >
    <template v-slot:text>
      <p class="text-subtitle-1">
        {{ message }}
      </p>
    </template>
    <template v-slot:actions>
      <v-icon icon="mdi-close" @click="hideSnackbar"> </v-icon>
    </template>
  </v-snackbar>
</template>
<script lang="ts" setup>
import { SnackbarType } from "~/core/enums";

const props = defineProps<{
  message: string;
  type: SnackbarType;
  hideSnackbar: () => void;
}>();

const show = defineModel<boolean>("show", { required: true });

function getSnackBarColor(): string {
  switch (props.type) {
    case SnackbarType.error:
      return "error";
    case SnackbarType.success:
      return "secondary-background";
    default:
      return "secondary";
  }
}
</script>
